import React from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, CenteredWorkflowLayout, Flex, HR, ListRowButton } from '@betterment/style-closet-react';

import { RequestValues } from './Controller';

import { Customer } from '../Checking/data';
import { ModalContent, ModalOverlay } from '../Checking/modal-helpers';
import { locationAssign } from '../Shared/path-helpers';

export interface SelectAccountStepProps extends StepProps<RequestValues> {
  customer: Customer;
}

const SelectAccount: React.FC<React.PropsWithChildren<SelectAccountStepProps>> = ({
  customer,
  goToNextStep,
  flowState,
}) => {
  return (
    <ModalOverlay>
      <ModalContent aria-label="account type selection">
        <CenteredWorkflowLayout
          title="Joint Checking"
          heading="How would you like to set up your Joint Checking account?"
          closeHandler={() => locationAssign(flowState.returnToPath)}
        >
          <CenteredWorkflowLayout.Slot name="content">
            <Flex justifyContent="left" mb="9">
              <Text>
                You’ll both have full access to the account and your own Betterment Visa&reg; Debit Cards, whichever way
                you choose to set it up.
              </Text>
            </Flex>
            <HR variant="list-row" />
            <Box bg="bmtWhite">
              <ListRowButton
                variant="expanded"
                leadingTitle="Add someone to your existing account"
                trailingIcon={<Icon name="CaretRight" size="small" />}
                onPress={() => {
                  track('ElementClicked', { name: 'CreateNewJCAccount', flow: 'OpenJointCheckingPrimary' });
                  goToNextStep({ accountId: customer.accounts[0].id });
                }}
              />
            </Box>
            <HR variant="list-row" />
            <Box bg="bmtWhite">
              <ListRowButton
                variant="expanded"
                leadingTitle="Open a new account with someone"
                trailingIcon={<Icon name="CaretRight" size="small" />}
                onPress={() => {
                  track('ElementClicked', { name: 'AddSomeoneToJCAccount', flow: 'OpenJointCheckingPrimary' });
                  goToNextStep();
                }}
              />
            </Box>
            <HR variant="list-row" />
          </CenteredWorkflowLayout.Slot>
        </CenteredWorkflowLayout>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SelectAccount;
